import React from 'react';
import { NotificationT } from '~/libs/soopI18n';
const ConfirmLayer = ({
    form,
    hiddenBottomButton,
    onClose,
    onConfirm
}: {
    form: React.ReactNode;
    hiddenBottomButton: boolean;
    onClose: () => void;
    onConfirm: () => void;
}) => {

    return (
        <div className="modal-layer terms_detail_layer">
            {form}
            {!hiddenBottomButton && (
                <div className="btn-area">
                    <button
                        type="button"
                        className="_btn_line"
                        onClick={onClose}>
                        {NotificationT('취소')}
                    </button>
                    <button
                        type="button"
                        className="_btn_tertiary"
                        onClick={onConfirm}>
                        {NotificationT('확인하고 동의')}
                    </button>
                </div>
            )}
            <button type="button" className="modal-close" onClick={onClose}>
                레이어 닫기
            </button>
        </div>
    );
};
export default ConfirmLayer;
